import {inject, Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {ObjectNewPageComponent} from './object-new-page.component';
import {Observable} from 'rxjs';
import {PrimusRouterService} from '../../core/primus-router.service';

@Injectable()
export class CanDeactivateObjectNewPage  {
  // Injections
  private readonly primusRouter: PrimusRouterService = inject(PrimusRouterService);

  canDeactivate(
    component: ObjectNewPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.primusRouter.checkCancel();
  }
}
